jQuery('.donation-form__predefined_amount').on('click', function () {
    var amount = jQuery(this).data('amount');
    jQuery('#amount-eur').val(amount);

    // Remove active class from all predefined amounts
    jQuery('.donation-form__predefined_amount').removeClass('active');

    // Add active class to the clicked predefined amount
    jQuery(this).addClass('active');

    const mdlAmount = convertToEur(amount);

    // Update the custom MDL value
    jQuery('#amount-mdl').val(mdlAmount);
});

let exchangeRate = 1;

function getExchangeRate() {
    fetch('https://api.app.fagura.com/api/currency')
        .then(response => response.json())
        .then(data => {
            exchangeRate = data.value;

            // Update the custom MDL value
            const amount = jQuery('#amount-eur').val();
            const mdlAmount = convertToEur(amount);

            jQuery('#amount-mdl').val(mdlAmount);
        });
}

getExchangeRate();

function convertToEur(amount) {
    return (amount * exchangeRate).toFixed(2);
}

// Add event listener to the custom amount input
jQuery('#amount-eur').on('input', function () {
    const amount = jQuery(this).val();
    const mdlAmount = convertToEur(amount);

    // Update the custom MDL value
    jQuery('#amount-mdl').val(mdlAmount);

    // Remove active class from all predefined amounts
    jQuery('.donation-form__predefined_amount').removeClass('active');
});

// Add event listener to the custom MDL input
jQuery('#amount-mdl').on('input', function () {
    const amount = jQuery(this).val();
    const eurAmount = (amount / exchangeRate).toFixed(2);

    // Update the custom EUR value
    jQuery('#amount-eur').val(eurAmount);

    // Remove active class from all predefined amounts
    jQuery('.donation-form__predefined_amount').removeClass('active');

});

// Add event listener to the submit button
jQuery('#submit-donation').on('click', function () {
    donate();
});

function donate() {

    const body = getFormData();

    if (parseFloat(body['amount']) < 1) {
        alert('Vă rugăm să introduceți o sumă validă');
        return;
    }
    if (body['firstName'] === '' || body['firstName'] === null) {
        alert('Numele este obligatoriu');
        return;
    }
    if (body['lastName'] === '' || body['lastName'] === null) {
        alert('Prenumele este obligatoriu');
        return;
    }

    if (body['email'] === '' || body['email'] === null) {
        alert('Email-ul este obligatoriu');
        return;
    }

    // Check if #confirm-donation is checked
    if (!jQuery('#confirm-donation').is(':checked')) {
        alert('Vă rugăm să acceptați termenii și condițiile');
        return;
    }

    // Check if the email is valid
    const email = body['email'];
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
        alert('Email-ul nu este valid');
        return;
    }

    // Check if the phone number is valid
    const phone = body['phone'];
    const phoneRegex = /^\+?(\d{2})?\s?\(?0?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{3}$/;

    if (!phoneRegex.test(phone)) {
        alert('Numărul de telefon nu este valid');
        return;
    }

    // Check if the country is valid
    const country = body['country'];
    if (country === '' || country === null) {
        alert('Țara este obligatorie');
        return;
    }

    // Check if the city is valid
    const city = body['city'];
    if (city === '' || city === null) {
        alert('Orașul este obligatoriu');
        return;
    }

    // Check if the address is valid
    const address = body['address'];
    if (address === '' || address === null) {
        alert('Adresa este obligatorie');
        return;
    }

    body['lang'] = 'ro';

    body['amount'] = parseFloat(body['amount']).toFixed(0);

    if (getUrlParameter('utm_source')) {
        body['utm_source'] = getUrlParameter('utm_source');
    }

    if (getUrlParameter('utm_medium')) {
        body['utm_medium'] = getUrlParameter('utm_medium');
    }

    if (getUrlParameter('utm_campaign')) {
        body['utm_campaign'] = getUrlParameter('utm_campaign');
    }

    jQuery('#submit-donation').prop('disabled', true);

    // Store the body data in local storage
    localStorage.setItem('donationData', JSON.stringify(body));

    // Redirect to the payment page
    window.open(`https://app.fagura.com/public-payment?amount=${body['amount']}&email=${body['email']}&FirstName=${body['firstName']}&LastName=${body['lastName']}&phone=${body['phone']}`, '_blank');

    // jQuery.get(
    //     `https://app.fagura.com/public-payment?amount=${body['amount']}&email=${body['email']}&FirstName=${body['firstName']}&LastName=${body['lastName']}&phone=${body['phone']}`,
    //     function (result) {
    //         for (let i = 0; i < Object.keys(result).length; i++) {
    //             prepopulateForm(Object.keys(result)[i], result[Object.keys(result)[i]]);
    //         }

    //         jQuery('#submit_second_form').trigger('click', (e) => {
    //             alert(result);
    //         });

    //         jQuery('#submit-donation').removeAttr('disabled');
    //     }
    // ).fail(function (e) {
    //     console.log(e);
    //     jQuery('#submit-donation').removeAttr('disabled');
    // });
}

function getUrlParameter(sParam) {
    let sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
}

function prepopulateForm(key, value) {
    jQuery('<input>').attr({
        type: 'hidden',
        id: key,
        name: key,
        value: value,
    }).appendTo('#donate_confirmation');
}

function getFormData() {
    const data = {};

    data['amount'] = jQuery('#amount-eur').val();
    data['amountMdl'] = jQuery('#amount-mdl').val();
    data['firstName'] = jQuery('#firstName').val();
    data['lastName'] = jQuery('#lastName').val();
    data['email'] = jQuery('#email').val();
    data['phone'] = jQuery('#phone').val();
    data['country'] = jQuery('#country').val();
    data['city'] = jQuery('#city').val();
    data['address'] = jQuery('#address').val();

    return data;
}

function getInitialData() {
    jQuery.ajax({
        url: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTSf18zIIY5flmYWLaBjZGVhv8YqGF0WeeY8HbqHV9ZlZTWy4gB8b79XzMa5bEBScGpKfoXAHqFQQWE/pub?output=csv',
        type: 'GET',
        dataType: 'json',
        success: function (result) {
            console.log({ result });
            jQuery.ajax({
                url: 'https://api.app.fagura.com/api/currency',
                type: 'GET',
                dataType: 'json',
                success: function (data) {
                    const { sheets } = result;
                    let personsWhoDonated = parseInt(sheets[0].data[0].rowData[1].values[2].formattedValue);
                    const moneys = sheets[0].data[0].rowData[1].values[0].formattedValue;
                    const target = sheets[0].data[0].rowData[1].values[1].formattedValue;

                    let collected_amount_value = parseInt(moneys.replace(',', '').replace('.', '')) / data.value;
                    const target_amount = parseInt(target.replace(',', '').replace('.', ''));

                    jQuery.ajax({
                        url: 'https://api.app.fagura.com/api/public/donations',
                        type: 'GET',
                        processData: false,
                        contentType: 'application/json',
                        success: function (result) {
                            if (result != null && result.length > 0) {
                                const sum = result[0]['sum'];
                                const total = result[0]['total'];

                                if (sum != null || sum !== undefined) {
                                    collected_amount_value += parseInt(sum) / parseInt(data.value);
                                }

                                if (total != null || total !== undefined) {
                                    personsWhoDonated += parseInt(total);
                                }

                                const width = (collected_amount_value / target_amount) * 100;

                                // Convert the trees-kg value to a string with commas and spaces for thousands
                                let treesKg = collected_amount_value.toFixed(0) * 20;
                                treesKg = treesKg.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");


                                jQuery('#donated-eur-amount').text(`${parseInt(collected_amount_value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}€`);
                                jQuery('#donors-count').text(total);
                                jQuery('#trees-value').text(collected_amount_value.toFixed(0));
                                jQuery('#trees-kg').text(treesKg);
                                jQuery('#progressBarLoad').css('width', `${width}%`);
                                jQuery('#progressBarLoad').attr('aria-valuenow', `${width}`);
                            }
                        },
                        error: function (e) {
                            console.log(e);
                        },
                    });
                }
            });
        },
        error: function (e) {
            console.log(e);
        },
    });
}
// getInitialData();

function checkIfSuccessPage() {

    const localData = localStorage.getItem('donationData');

    if (localData === null) return;

    // Check if the URL contains the success parameter
    const donationData = JSON.parse(localStorage.getItem('donationData'));

    // Check if the current URL contains the success parameter, even if it's empty (?success)
    const success = window.location.href.includes('?success');

    if (success) {
        // Clear the local storage
        localStorage.removeItem('donationData');
        return;
    }


    if (donationData !== null) {
        // Create a FormData object from body variable
        const formData = new FormData();
        for (const key in donationData) {
            formData.append(key, donationData[key]);
        }

        formData.append('sum', donationData.amount);
        formData.append('status', 'confirmat');
        formData.append('data', new Date().toISOString());

        fetch('https://script.google.com/macros/s/AKfycbxLrIa-6TsQ9nouzxLq0j_Xh-PibyvySFAl-AFzD0Rc5bg7-8v66tf-l1yNeNRnui57/exec', {
            method: 'POST',
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                if (data.result === 'success') {
                    // alert('Data sent successfully! Row: ' + data.row);
                } else {
                    console.log('Error: ' + data.error);
                }
            })
            .catch(error => {
                alert('Error: ' + error.message);
            });

        // Clear the local storage
        localStorage.removeItem('donationData');
    }

}
checkIfSuccessPage();